/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles, textStyles, linkStyles, themeV2, toolTipStyles, iconStyles } from "utils/themeV2";

/* ++++++++++ --------------- EXPORT : EMBED SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
    '@global': {
      ...toolTipStyles,
      '.button.variant-action': {
        background: `${themeV2.color.success.dark} !important`
      },
      '.button.variant-delete': {
        background: `${themeV2.color.error.main} !important`,
        color: `${themeV2.color.error.contrast.main} !important`,
        '& .loader div': { borderTopColor: `${themeV2.color.error.contrast.main} !important` }
      },
      '.button.variant-system': {
        background: `${themeV2.color.system.main} !important`,
        color: `${themeV2.color.system.contrast.main} !important`,
        border: '0',
        '& .loader div': { borderTopColor: `${themeV2.color.system.contrast.main} !important` }
      },
      '.button.variant-primary': {
        background: `${themeV2.color.primary.main} !important`,
        color: `${themeV2.color.primary.contrast.main} !important`,
        '& .loader div': { borderTopColor: `${themeV2.color.primary.contrast.main} !important` },
        '&:hover': {
          background: `${themeV2.color.primary.light} !important`,
          filter: 'none'
        },
        '&:focus': {
          background: `${themeV2.color.primary.main} !important`,
          border: `1px solid ${themeV2.color.base.button.border.focus} !important`
        },
        '&:active': {
          border: 0
        }
      },
      '.dropdownindicator': {
        '&:hover': {
          borderColor: `${themeV2.color.base.gray.dark} !important`,
        }
      }
    },
    embeds: {
    	'& #subhead': {
        background: themeV2.color.background.light.blue,
        color: themeV2.color.primary.main,
            '& .embedheadername': {
                marginRight: pxToEm(15),
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                '& .embedname': {
                    animationDelay: '1.1s',
                    color: `${themeV2.color.primary.light} !important`
                }, 
            },
    		
            '& .ctas': {
                '& .link': {
                    animationDelay: '1.1s',
                    '& .loader': {
                        '& div': { borderTopColor: '#fff' }
                    }
                }
            }
    	},
      ...textStyles,
      ...linkStyles,
      '& .iconOnly-true': {
        '& .icon': {
          color: `${themeV2.color.base.gray.dark} !important`
        }
      },

      '& .embedname': {
        '& .name': { color: `${themeV2.color.primary.light} !important` }
      },
      '& .header-divider': {
        fontSize: '24px',
        margin: pxToEm(8)
      },
      '& .contentselector': {
        '& .title ': { color: `${themeV2.color.primary.light} !important` }
      }
    }
});
